import React, { Component } from 'react';
import { FormFieldFunctions } from '../../interfaces/FormField/FormField';
import Snapshot from '../../interfaces/Snapshot/Snapshot';
import FormFieldRadioProps from './FormFieldRadio.props';
import FormFieldRadioState from './FormFieldRadio.state';

export default class FormFieldRadio extends Component<FormFieldRadioProps, FormFieldRadioState> implements FormFieldFunctions {
    private block: React.RefObject<HTMLDivElement>;

    constructor(props: FormFieldRadioProps) {
        super(props);
        const selected = this.props.options
            && this.props.options[0]
            && this.props.options[0].value
            ? this.props.options[0].value : undefined;
        this.state = {
            selected: this.props.selected || selected
        };

        this.block = React.createRef<HTMLDivElement>();
        this.handleChange = this.handleChange.bind(this);
    }

    updateAndNotify = () => {
        this.setState({
            selected: this.props.selected
        });
    }

    getSnapshotBeforeUpdate(prevProps: FormFieldRadioProps): Snapshot {
        return { notifyRequired: prevProps.selected !== this.props.selected };
    }

    componentDidUpdate(prevProps: FormFieldRadioProps, prevState: FormFieldRadioState, snapshot: Snapshot) {
        if (snapshot.notifyRequired) {
            this.updateAndNotify();
        }
    }

    componentDidMount() {
        try {
            window.Juris.moduleRegistry.autoApplyModule('Tooltip', '[data-tooltip]');
        } catch (error) {
            console.log(error);
        }
    }

    handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            selected: e.target.value
        }, this.props.onChange);
    }

    isValid() {
        if (this.props.required && (this.state.selected === undefined || this.state.selected.trim() === '')) {
            return false;
        }

        return true;
    }
    
    toggleValidationError(show: boolean) {
        if (show) {
            this.block.current?.parentElement?.classList.add('form__field--error');
        } else {
            this.block.current?.parentElement?.classList.remove('form__field--error');
        }
    }

    getValue() {
        return this.state.selected;
    }

    render(): React.ReactNode {
        return (
            <div className="form__col col col-12" data-testid="FormFieldWrapper">
                <div className="form__field">
                    <div className="input-radio" data-testid="FormFieldRadio" ref={this.block}>
                        {this.props.label ? (
                            <>
                                <span className="input-radio__label">{this.props.label}
                                    {this.props.labelSubElement ? (
                                        <div className="input-radio__label-sub input-radio__label-sub--link">
                                            {this.props.labelSubElement}
                                        </div >
                                    ) : null}
                                </span>
                            </>
                        ) : null}
                        {
                            this.props.info
                                ? <div className="input-radio__info" data-tooltip={false}>
                                    <span className="icon_error-circle_alt"></span>
                                    {
                                        this.props.info.label
                                            ? <span className="input-radio__info-label">{this.props.info.label}</span>
                                            : null
                                    }
                                    {
                                        this.props.isInPPO
                                            ? <div className="input-radio__info-tooltip" 
                                                data-tooltip-content={false}>
                                                <span className="icon_error-circle_alt"></span>
                                                <div className="textblock" dangerouslySetInnerHTML={{
                                                    __html: this.props.info.text
                                                }}></div>
                                                <span className="cta-overlay-button__close-btn-icon"></span>
                                            </div>
                                            : <div className="input-radio__info-tooltip" 
                                                data-tooltip-content={false}
                                                dangerouslySetInnerHTML={{
                                                    __html: this.props.info.text
                                                }}>
                                            </div>
                                    }
                                    
                                </div>
                                : null
                        }
                        <div className="input-radio__options">
                            {
                                this.props.options.map((option, index) => {
                                    return <div className="input-radio__option-container"
                                        key={this.props.id + index}>
                                        <input type="radio"
                                            id={this.props.id + index}
                                            name={this.props.name || this.props.id}
                                            value={option.value}
                                            className="input-radio__option"
                                            disabled={option.disabled}
                                            data-testid="Option"
                                            checked={this.state.selected === option.value}
                                            onChange={this.handleChange} />
                                        <label htmlFor={this.props.id + index}
                                            className="input-radio__option-label">{option.label}</label>
                                    </div>;
                                })
                            }
                        </div>
                    </div>
                    {
                        this.props.hint
                            ? <span className="form__field-hint">{this.props.hint}</span>
                            : null
                    }
                    {
                        this.props.errorMessage
                            ? <div className="form__field-error-message">{this.props.errorMessage}</div>
                            : null
                    }
                </div>
            </div>
        );
    }
}
